import { render, staticRenderFns } from "./TalkCodeBlock.vue?vue&type=template&id=4ce34e45&scoped=true"
import script from "./TalkCodeBlock.vue?vue&type=script&lang=js"
export * from "./TalkCodeBlock.vue?vue&type=script&lang=js"
import style0 from "./TalkCodeBlock.vue?vue&type=style&index=0&id=4ce34e45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce34e45",
  null
  
)

export default component.exports